var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 75,
    r: 11,
    fill: "#f47e60"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0;1;1",
    keyTimes: "0;0.2;1",
    begin: "0s"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 47A28 28 0 0 1 56 75",
    fill: "none",
    stroke: "#f8b26a",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0;1;1",
    keyTimes: "0;0.2;1",
    begin: "0.1s"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 25A50 50 0 0 1 78 75",
    fill: "none",
    stroke: "#abbd81",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0;1;1",
    keyTimes: "0;0.2;1",
    begin: "0.2s"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.a4c355b5cf0907c8823cd18e1f77a4d0.svg";
export { ForwardRef as ReactComponent };